import React, { Component } from 'react';
import { observable } from 'mobx';
import RValueField from './rvaluefield.component';
import NumberField from '../numberfield/numberfield.component';
import { observer } from 'mobx-react/index';

import './rvaluefield.scss';

@observer
export default class PercentRValueField extends Component {
    @observable warning = false;

    constructor(props) {
        super(props);
        this.rvalueField = React.createRef();
        this.warning = false;
    }

    /**
     * Need to be able to pass showing or hiding from the child rValueField component to this
     * parent. We do that by passing a callback function through props to the child. Then when
     * the child 'ShowParentWarning' observable changes, we call that function. We also need
     * to call this callback in the child constructor so we can determine if we need to show
     * the message on initial load
     * @param {bool} show
     */
    triggerShowWarning(show = false) {
        this.warning = show;
    }

    render() {
        const { label, numberField, rvalueField, description, name, extra } = this.props,
            { hint } = extra;

        return (
            <div className='ht-field ht-percentrvaluefield'>
                {label && (
                    <label
                        htmlFor={name}
                        className='bx--label ht-percentrvaluefield-label'
                    >
                        {label}
                    </label>
                )}
                {/* else use the label from the numberfield */}
                {!label && numberField && numberField.label && (
                    <label
                        htmlFor={numberField.name}
                        className='bx--label ht-percentrvaluefield-label'
                    >
                        {numberField.label}
                    </label>
                )}
                {description && (
                    <div className='bx--form__helper-text ht-percentrvaluefield-label'>
                        {description()}
                    </div>
                )}
                <div className='ht-percentrvaluefield-number'>
                    <NumberField
                        errors={numberField.errors}
                        {...numberField.bind()}
                        {...numberField.get('extra')}
                        description={false}
                        showErrors={false}
                    />
                </div>
                <div className='ht-percentrvaluefield-rvalue'>
                    <RValueField
                        field={rvalueField}
                        errors={rvalueField.errors}
                        {...rvalueField.bind()}
                        {...rvalueField.get('extra')}
                        description={false}
                        showErrors={false}
                        showHint={false}
                        ref={this.rvalueField}
                        triggerParentWarning={(show) => this.triggerShowWarning(show)}
                    />
                </div>

                {this.warning && (
                    <p className='ht-field-warning'>{this.warning}</p>
                )}

                {hint && (
                    <p className='ht-field-hint'>{hint}</p>
                )}
                <div className='ht-percentrvaluefield-errors'>
                    {/* area for errors */}
                    {numberField.errors && (
                        <div
                            className='bx--form-requirement'
                            id={`${numberField.name}-error-msg`}
                        >
                            {numberField.errors}
                        </div>
                    )}
                    {rvalueField.errors && (
                        <div
                            className='bx--form-requirement'
                            id={`${rvalueField.name}-error-msg`}
                        >
                            {rvalueField.errors}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
